import { v4 as uuid } from 'uuid';
import { makeVar } from '@apollo/client';
import type {
  MinimalNotification,
  MutationaddMinimalNotificationArgs,
  MutationremoveMinimalNotificationArgs,
} from 'types/__generated__/graphql-global-types';

const initialData: MinimalNotification[] = [];

export const minimalNotificationsVar = makeVar<MinimalNotification[]>(initialData);

const readNotifications = (): MinimalNotification[] => {
  try {
    const notifications = minimalNotificationsVar();

    return notifications;
  } catch {
    return [];
  }
};

const writeNotifications = (notifications: MinimalNotification[]) => {
  minimalNotificationsVar(notifications);
};

export const resolvers = {
  Query: {
    minimalNotifications: readNotifications,
  },

  Mutation: {
    addMinimalNotification: (_: never, args: MutationaddMinimalNotificationArgs) => {
      const { notification } = args;

      const notifications = readNotifications();

      try {
        const newNotifications: MinimalNotification[] = [
          ...notifications,
          {
            __typename: 'MinimalNotification',
            id: uuid(),
            message: notification.message,
          },
        ];
        writeNotifications(newNotifications);
        return true;
      } catch {
        return false;
      }
    },

    removeMinimalNotification: (_: never, args: MutationremoveMinimalNotificationArgs) => {
      const { id } = args;

      const notifications = readNotifications();

      try {
        const newNotifications = notifications.filter((notification) => notification.id !== id);
        writeNotifications(newNotifications);
        return true;
      } catch {
        return false;
      }
    },
  },
};
